import {
  RowScopedErrorsState,
  RowDataReducerActionPayload,
  RowDataReducerState,
} from "../../../types";

export const updateFieldValidationAction = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
): RowDataReducerState => {
  const { propertyKey, newFieldValueValidation, rowIndex, propertySubKey } =
    payload;

  if (!propertyKey || newFieldValueValidation === undefined) return state;

  let updatedErrors;

  if (rowIndex !== undefined && propertySubKey) {
    const currentRowErrors =
      (state.rowDataErrors[propertyKey] as RowScopedErrorsState) || {};
    const currentErrorsForRow = currentRowErrors[rowIndex] || {};

    updatedErrors = {
      ...state.rowDataErrors,
      [propertyKey]: {
        ...currentRowErrors,
        [rowIndex]: {
          ...currentErrorsForRow,
          [propertySubKey]: newFieldValueValidation,
        },
      },
    };
  } else {
    updatedErrors = {
      ...state.rowDataErrors,
      [propertyKey]: newFieldValueValidation,
    };
  }

  return {
    ...state,
    rowDataErrors: updatedErrors,
  };
};
